<template>
    <el-popover class="table-select" popper-class="table-select-popver" placement="right-start" width="auto"  trigger="click" v-model="popoverVisible"
        @show="handleShow">
        <el-table :data="data" @row-click="handleRowClick" v-loading="loading" :max-height="maxHeight" class="table"
            :row-class-name="rowClassName">
            <el-table-column v-for="column in columns" v-bind="column" :key="column.prop">
                <template #default="{ row }">
                    <div class="cell-content" :title="row[column.prop]">
                        {{ row[column.prop] || '--' }}
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-input slot="reference"  v-model="inputValue" @input="handleInput"
            @blur="handleSetLabel" @clear="handleClear" :clearable="clearable" placeholder="请输入内容" size="small"></el-input>
    </el-popover>
</template>
<script>
import { isObject } from 'lodash'
export default {
    props: {
        clearable: {
            type: Boolean,
            default: true
        },
        value: {
            type: [String, Number, Object],
            default: () => ({})
        },
        data: {
            type: Array,
            default: () => []
        },
        valueField: {
            type: String,
            default: `value`
        },
        labelField: {
            type: String,
            default: `label`
        },
        columns: {
            type: Array,
            default: () => []
        },
        loading: {
            type: Boolean,
            default: false
        },
        maxHeight: {
            type: Number,
            default: 300
        }
    },
    data() {
        return {
            popoverVisible: false,
            inputValue: ``,
            current: {}
        }
    },
    watch: {
        value: {
            handler() {
                if (isObject(this.value)) {
                    this.current = { ...this.value }
                }
                this.handleSetLabel()
            },
            immediate: true
        }
    },
    methods: {
        handleSetLabel() {
            this.inputValue = this.current[this.labelField]
        },
        handleClear() {
            this.$emit(`update:value`, {})
            this.$emit(`change`, {})
            this.current = { }
            this.handleSetLabel()
        },
        handleInput() {
            this.$emit(`filter`, this.inputValue)
            this.popoverVisible = true
        },
        handleRowClick(row) {
            this.$emit(`update:value`, { ...row })
            this.$emit(`change`, { ...row })
            this.current = { ...row }
            this.handleSetLabel()
            this.popoverVisible = false
        },
        handleShow() {
            this.$emit(`show`)
        },
        rowClassName({ row }) {
            const value = this.value || {}
            if (row[this.valueField] === value[this.valueField]) return `highlight`
        }
    }
}
</script>
<style lang="less">
.table-select-popver{
    max-width: 95vw;
}
</style>
<style scoped lang="less">
@import '../assets/themes/base.less';
.table-select {
    .el-input {
        width: 100%;
        height: 40px;
        line-height: 40px;
        cursor: pointer;
    }
    .table{
        max-width: 100%;
    }
}

.cell-content {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/deep/ .highlight {
    background-color: @primary !important;
    color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/common/TableSelect.vue